module.exports = __webpack_public_path__ + "static/media/gsNl3i.b19e328b.png";